import * as React from 'react';
import { SVGProps } from 'react';
export const IconChatUIAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 104 104'
    fill='none'
    {...props}
  >
    <path
      fill='#228BE6'
      fillRule='evenodd'
      d='M61.537 13.097a468.64 468.64 0 0 0-35.727.636c-10.326.651-19.394 9.574-20.233 19.93-.936 13.287-.936 20.224 0 33.544.807 10.356 9.875 19.279 20.234 19.93 5.163.293 10.552.489 15.78.619l.032 12.994c7.615 0 12.703-4.488 16.792-8.095l.053-.047c3.42-2.996 5.647-4.852 8.52-4.95 3.969-.293 7.97-.618 12.004-1.01 10.165-1.009 18.685-9.737 19.46-19.897.783-11.38.887-17.986.29-28.14a23.712 23.712 0 0 1-12.712 4.674c.326 7.488.16 13.265-.487 22.521-.258 3.745-4.001 7.49-7.81 7.881-3.904.391-7.809.717-11.423.977-7.325.227-12.283 4.585-16.275 8.094l-.054.048c-3.453 3.061-5.712 4.95-8.39 4.95V74.73a379.36 379.36 0 0 1-15.038-.587c-3.873-.228-7.81-4.07-8.1-7.88-.904-12.67-.904-18.987 0-31.59.29-3.843 4.227-7.718 8.067-7.946 11.642-.65 23.39-.853 35.078-.608a23.845 23.845 0 0 1-.931-6.619c0-2.218.303-4.366.87-6.403Z'
      clipRule='evenodd'
    />
    <path
      fill='#E03131'
      fillRule='evenodd'
      d='M84.5 0C73.73 0 65 8.73 65 19.5S73.73 39 84.5 39 104 30.27 104 19.5 95.27 0 84.5 0Zm0 10.43c1.002 0 1.814.812 1.814 1.814V19.5a1.814 1.814 0 0 1-3.628 0v-7.256c0-1.002.812-1.814 1.814-1.814Zm-1.814 16.326c0-1.002.812-1.814 1.814-1.814h.018a1.814 1.814 0 1 1 0 3.628H84.5a1.814 1.814 0 0 1-1.814-1.814Z'
      clipRule='evenodd'
    />
  </svg>
);
